
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import useAppState from '@/composables/ui/ui'
import { PostsRoot } from '@/composables/post/postList'
import useConfiguration from '@/composables/configuration/configuration'
import { DateTimeHelper } from '@/helper/dateTime'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'PostInformation',
  emits: ['toggle-edit-form'],
  components: { AIcon, AButton },
  props: {
    postRoot: {
      type: PostsRoot,
      required: true,
    },
    showIp: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    modifiedAtFormatted() {
      if (this.postRoot.post && this.postRoot.post.editedAt) {
        return DateTimeHelper.formatDateTime(this.postRoot.post.editedAt)
      }

      return ''
    },
    dateTimeFormatted() {
      if (this.postRoot.post) {
        return DateTimeHelper.formatDateTime(this.postRoot.post.createdAt)
      }

      return ''
    },
  },
  setup() {
    return {
      ...useConfiguration(),
      ...useRouter(),
      ...useAppState(),
    }
  },
})
